import { useState } from "react"

// helpers
import Api from "./Api"

// libraries
import { enqueueSnackbar } from "notistack"

// providers
import { trans } from "@/_providers/Translation"

export default function useReservationOpenToggle() {
    const [loading, setLoading] = useState(false)

    function toggleReservationOpen(state, taskId, onSuccess) {
        setLoading(true)
        Api.post('reservations/toggle-address-open', {
            id: taskId,
            is_open: state
        })
            .then(res => {
                onSuccess(res.data)
                enqueueSnackbar(
                    !state ? trans("messages.reservationClosed") : trans("messages.reservationOpened"),
                    {
                        variant: "success",
                    },
                )
            })
            .catch(() => {
                enqueueSnackbar(
                    !state ? trans("messages.reservationCloseError") : trans("messages.reservationOpenError"),
                    {
                        variant: "error",
                    },
                )
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return {
        loadingReservationOpenToggle: loading,
        toggleReservationOpen
    }
}